
/**
 * Create POST headers
 *
 * @return Object
 */
export const getAuthHeaders = () => {
    return {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json'
    };
};

/**
 * Create POST headers using access or refresh token
 *
 * The bodies are plain objects that api-mgmt reads as JSON. axios 1.x encodes
 * an object to match its Content-Type, so these must say JSON; a form type
 * would send a=1&b=2. A FormData body takes getUploadPostHeaders instead.
 *
 * @param useBearer
 * @return {{"Cache-Control": string, "Content-Type": string}}
 */
export const getPostHeaders = (useBearer) => {
    const headers = {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json'
    };
    if (useBearer === false) {
        headers.Authorization = undefined;
    }
    return headers;
};

/**
 * Create POST headers for a FormData upload
 *
 * No Content-Type: with a JSON one axios 1.x would turn the FormData into a
 * JSON string. Without one it passes the FormData through and the browser
 * sets multipart/form-data with its boundary.
 *
 * @return {{"Cache-Control": string}}
 */
export const getUploadPostHeaders = () => {
    return {
        'Cache-Control': 'no-cache'
    };
};

/**
 * Create GET headers
 *
 * @return Object
 */
export const getGetHeaders = () => {

    return {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
    };
};

/**
 * Create DELETE headers using access or refresh token
 *
 * @param useBearer
 * @return {{"Cache-Control": string, "Content-Type": string}}
 */
export const getDeleteHeaders = (useBearer) => {
    const headers = {
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json'
    };
    if (useBearer === false) {
        headers.Authorization = undefined;
    }
    return headers;
};
